"use client";

import { getMatchDisplayTime } from "@/utils/matchInfo";

import "./ViuGoOddsMatchTime.css";

export default function ViuGoOddsMatchTime({
    match,
    isLive,
    formattedDate,
    formattedGio,
    liveScore,
    statusNum,
}) {
    const displayTime = getMatchDisplayTime(
        liveScore,
        statusNum,
        match?.matchTime,
        match?.halfStartTime,
    );

    const halfLabel = isLive ? (displayTime?.halfLabel || "Live") : "Sớm";
    const minuteText = isLive ? (displayTime?.content || "") : formattedGio;

    return (
        <div className="flex w-[6%] flex-wrap justify-center border-t-0 border-l-0 border-b border-solid border-[var(--theme-border)]">
            <div className="flex w-full flex-col items-center justify-center gap-1 py-2">
       
                <div className="min-w-[34px]">
                    {isLive ? (
                        <div className="flex flex-col gap-2 text-[12px] font-bold">
                            <span className="kbv-text-time-indigo-slate">{halfLabel}</span>
                            <div className="kbv-text-result-indigo-slate text-[12px]">
                                {minuteText}{" "}
                                <span className="viugo-odds-match-time__live-minus kbv-text-result-indigo-slate text-xl">
                                    '
                                </span>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-2 text-[12px] font-bold">
                            <span className="kbv-text-time-indigo-slate">
                                {formattedDate} 
                            </span>
                            <span className="text-[var(--text-half-score)]">
                                {formattedGio}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

